/* eslint-disable prefer-regex-literals */
import React, {
    useCallback,
    useMemo,
    useState,
} from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'

import styles from './CartaScanResult.style'

const propTypes = {
    scanResult: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onRetry: PropTypes.func.isRequired,
}

const CartaScanResult = ({
    scanResult = '',
    onConfirm,
    onRetry,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    const [
        viewActions,
        setViewActions,
    ] = useState(true)

    const handleConfirm = useCallback(() => {
        onConfirm()
        setViewActions(false)
    }, [
        onConfirm,
        setViewActions,
    ])

    const validate = useCallback((v) => {
        const inputRegexp = new RegExp(/\b\d{6}\b|\b\d{10}\b/)

        if (v.match(inputRegexp)) {
            return true
        }
        return false
    }, [])

    const errorText = useMemo(() => {
        if (scanResult && !validate(scanResult)) {
            return t('CARTASENSE_BARCODE_VALIDATION_MESSAGE', { barCode: scanResult })
        }
        return null
    }, [
        scanResult,
        validate,
        t,
    ])

    return (
        <div css={classes.result}>
            {scanResult && !errorText && (
                <div>
                    {`${t('SELECTED_CARTA_LOGGER')} ${scanResult}` }
                </div>
            )}
            { errorText && (
                <>
                    <div>
                        {errorText}
                    </div>
                    <div css={classes.error}>
                        {t('CARTASENSE_BARCODE_MANUAL_VALIDATION_MESSAGE')}
                    </div>
                </>
            )}

            {viewActions && (
                <div css={classes.actions}>
                    {!errorText && (
                        <Button
                            data-testid="confirm-button"
                            css={classes.button}
                            onClick={handleConfirm}
                        >
                            {t('CONFIRM')}
                        </Button>
                    )}
                    <Button
                        data-testid="retry-button"
                        css={classes.button}
                        onClick={onRetry}
                    >
                        {t('RETRY')}
                    </Button>
                </div>
            )}
        </div>
    )
}

CartaScanResult.propTypes = propTypes

export default CartaScanResult
